// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__Lw3oq","Thead":"Table_Thead__-ee4c","Tbody":"Table_Tbody__TqEN5","NotFoundMsg":"Table_NotFoundMsg__qXee2","Pagination":"Table_Pagination__n-1Nh"};